/**
 * Utility functions for microphone audio level conversion and calculation
 */

/**
 * Calculate the audio bar level from an audio analyzer
 *
 * @param {AnalyserNode} analyzer - The Web Audio API analyzer node
 * @param {number} totalSegments - The total number of segments in the visualization
 * @returns {number} - The calculated audio level (0-totalSegments)
 */
export const calculateAudioBarLevel = (analyzer, totalSegments) => {
    // Create data array based on the analyzer's frequencyBinCount
    const dataArray = new Uint8Array(analyzer.frequencyBinCount);

    // Get frequency data from the analyzer
    analyzer.getByteFrequencyData(dataArray);

    // Calculate volume level from audio data
    // Take average of frequency data and map to 0-totalSegments range
    const average = dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length;

    // eslint-disable-next-line no-mixed-operators
    const normalizedAvg = Math.floor(average * (totalSegments + 1) / (dataArray.length + 1));

    // Ensure the level doesn't exceed totalSegments
    const level = Math.min(normalizedAvg, totalSegments);

    return level;
};

export default {
    calculateAudioBarLevel,
};
